import { Upload } from "./base.js";

//#region ../base/upload/base-url.ts
var UploadUrl = class extends Upload {
	url;
	constructor(params) {
		super(params);
		this.url = params.url;
	}
	async start() {
		if (await super.start() !== true) return;
		await this.handleUploadFinished();
		return true;
	}
};

//#endregion
export { UploadUrl };
//# sourceMappingURL=base-url.js.map